// jo-xyz-demo Configuration Constants

export const EXIT_ROUTE = '/dashboard';

export const REQUIRED_CONNECTORS = ['netsuite', 'quickbooks'];

export const CAPACITY_THRESHOLDS = { 
  ok: 0.7, 
  warn: 0.9 
};

// LTV (Loan-to-Value) Configuration
export const LTV_THRESHOLDS = { 
  good: 0.50, 
  caution: 0.65 
};

export const LTV_COLORS = {
  good: '#22C55E',      // Green for LTV ≤ 50%
  caution: '#F59E0B',   // Amber for LTV 50-65%
  danger: '#EF4444'     // Red for LTV > 65%
};

// Lien Position Types
export const LIEN_POSITIONS = [
  'FirstLien', 
  'SecondLien', 
  'Unencumbered'
];

// Asset Types
export const ASSET_TYPES = [
  'Property', 
  'Receivable', 
  'Equipment', 
  'Inventory'
];

// Property Subtypes
export const PROPERTY_SUBTYPES = [
  'Commercial Real Estate',
  'Residential',
  'Industrial',
  'Retail',
  'Multifamily'
];

// Listing Status
export const LISTING_STATUS = [
  'Open',
  'Matched',
  'Closed',
  'Expired',
  'Cancelled'
];

// Commitment Status
export const COMMITMENT_STATUS = [
  'Committed',
  'Accepted',
  'Rejected',
  'Withdrawn'
];

// Investor Types
export const INVESTOR_TYPES = [
  'Institutional',
  'Regional',
  'Fund',
  'Individual'
];

// Geographic Regions
export const GEOGRAPHIC_REGIONS = [
  'TX', 'CA', 'NY', 'FL', 'IL', 'PA', 'OH', 'GA', 'NC', 'MI'
];

// Default Values
export const DEFAULT_LIEN = 'FirstLien';
export const DEFAULT_TERM_MONTHS = 12;
export const DEFAULT_MIN_TICKET = 100000;
export const DEFAULT_MAX_TICKET = 5000000;

// Validation Rules
export const VALIDATION_RULES = {
  minPropertyValue: 500000,
  maxLtvForFirstLien: 0.80,
  maxLtvForSecondLien: 0.65,
  minTermMonths: 6,
  maxTermMonths: 60,
  minCapRate: 0.03,
  maxCapRate: 0.15
};

// Badge Configurations
export const BADGE_CONFIG = {
  'Property': { color: '#8B5CF6', text: '#FFFFFF' },
  'CRE': { color: '#6EE7F2', text: '#0B1020' },
  '1st-Lien': { color: '#22C55E', text: '#FFFFFF' },
  '2nd-Lien': { color: '#F59E0B', text: '#FFFFFF' },
  'Bridge Loan': { color: '#EF4444', text: '#FFFFFF' },
  'Refinance': { color: '#6EE7F2', text: '#0B1020' },
  'Expansion': { color: '#8B5CF6', text: '#FFFFFF' },
  'Encumbrance: None': { color: '#22C55E', text: '#FFFFFF' },
  'In Underwriting': { color: '#F59E0B', text: '#FFFFFF' }
};

// Demo Configuration
export const DEMO_CONFIG = {
  duration: '3-5 minutes',
  maxListingsPerPage: 12,
  maxCommitmentsPerListing: 10,
  autoRefreshInterval: 30000, // 30 seconds
  toastDuration: 5000
};
